// Category → palette preset mapping.
//
// Each market category maps to one of the brand presets in PALETTE_NAMES.
// This is the lib's source of truth for "what colour family does a market
// of this category render in?" — replaces the legacy CATEGORY_HUE_DEFS in
// frontend/src/config/market-icon.ts.
//
// Tweaking a category's palette = single line edit; every market in that
// category re-skins on the next render via the manifest hash flip.
//
// V1 mapping: every category points to the default `brand` preset until
// per-category brand presets land in palettes.ts. Per-pubkey seed jitter
// (applied via the manifest's outer `seed` field, not here) gives each
// market visual differentiation within a category.

import type { PaletteName } from './palettes';

export const CATEGORY_PALETTE_MAP: Readonly<Record<string, PaletteName>> = {
  politics: 'shadow', // dramatic
  sports: 'rich', // saturated
  crypto: 'classic', // balanced
  business: 'bold', // vivid
  tech: 'wide', // extreme spread
  culture: 'soft', // pale ethereal
  gaming: 'wide', // extreme spread
  lifestyle: 'soft', // pale ethereal
  other: 'brand', // default
};
